<section class="container">
  <header class="header">{{ 'Menu.items.rules' | translate }}</header>
  <div class="redline"></div>
  <div>
    <app-input [(value)]="searchValue" (valueChange)="handleSearchInputChange($event)" [title]="''"
      [placeholder]="'Common.Input.search' | translate" [startIcon]="startIcon" [disabled]="inputDisabled">
    </app-input>

    <app-info-block></app-info-block>

    <app-added-users-list (setOpened)="setAddModalOpened($event)"
      (setDeleteModalOpened)="setDeleteModalOpened($event)"></app-added-users-list>

    <app-build-in></app-build-in>
  </div>
</section>

<app-modal *ngIf="addModalOpened" [(visible)]="addModalOpened" [title]="'Common.Form.add' | translate">
  <div class="modalContent">
    <app-input [placeholder]="'Auth.form.placeholder' | translate" [title]="'Auth.form.emailInput' | translate"
      name="value" [(ngModel)]="emailValue">
    </app-input>

    <div class="type">{{ 'Toggler.Type' | translate }}</div>
    <app-chips active='Proxy' (handleChoose)="handleChoose('Proxy')"></app-chips>
  </div>

  <div class="modalActions">
    <div class="btnWrapper">
      <app-transparent-button [text]="'Common.Button.cancel' | translate"
        (onClick)="handleCancel()"></app-transparent-button>
    </div>
    <div class="btnWrapper">
      <app-button [text]="'Common.Button.add' | translate" (onClick)="handleAdd()"></app-button>
    </div>
  </div>
</app-modal>

<app-modal *ngIf="deleteModalOpened" [(visible)]="deleteModalOpened" [title]="'Common.Button.delete' | translate">
  <div>delete modal content</div>
</app-modal>